import React from 'react';
// Constants
import {
  CONTACT_PAGE_URL,
  LINKS_PAGE_URL,
} from '../../utils/Routes';
import {
  TWITTER_URL,
  REDDIT_URL,
} from '../../utils/Constants';
import { Link } from 'react-router-dom';

function CallToActionOne() {
  const buttons = [
    // {
    //   text: 'Spoil Me',
    //   link: LINKS_PAGE_URL,
    //   ariaLabel: 'Send a tribute to Miss Sammi',
    // },
    {
      text: 'Book Now',
      link: CONTACT_PAGE_URL,
      ariaLabel: 'Book a session with Miss Sammi',
    },
    {
      text: 'My Links',
      link: LINKS_PAGE_URL,
      ariaLabel: 'Explore Miss Sammi’s online presence',
    },
    {
      text: 'Twitter',
      link: TWITTER_URL,
      ariaLabel: 'Follow Miss Sammi on Twitter for updates',
    },
    {
      text: 'Reddit',
      link: REDDIT_URL,
      ariaLabel: 'See Miss Sammi’s posts on Reddit',
    },
  ];

  return (
    <div className='grid gap-4 h-fit py-2'>
      <section className='px-10 sm:px-12 md:px-16'>
        <p className='text-center text-lg'>
          Follow me and learn more about me by visiting my links below!
        </p>
      </section>
      <section className='grid justify-center h-fit md:grid-cols-4 mx-auto gap-x-6 gap-y-4 pb-6 md:w-fit'>
        {buttons.map((btn, index) => (
          <Link
            key={index}
            to={btn.link}
            className='cursor-pointer hover:bg-colour2 border-2 border-solid border-colour1 bg-colour5 px-10 h-fit md:px-4 lg:px-6 py-2 mx-auto w-full text-center shadow-cardShadow'
            title={btn.text}
            aria-label={btn.ariaLabel}
          >
            {btn.text}
          </Link>
        ))}
      </section>
    </div>
  );
}

export default CallToActionOne;
